import { IconContent } from '@icons';

export const arrowOutOfRectangle: IconContent = {
    sm: '<path d="M8.793 2h.5v3h-1V3h-6v10h6v-2h1v3h-8V2h7.5Zm1.646 8.146L12.086 8.5H5.793v-1h6.293l-1.647-1.646.707-.708 2.5 2.5L14 8l-.354.354-2.5 2.5-.707-.708Z" />',
};
